import Swiper from 'swiper/bundle'

export default function CategorySlider () {
  const SWIPER = new Swiper('.mtt-categories .swiper-container', {
    init: false,
    slidesPerView: 1.2,
    speed: 800,
    spaceBetween: 16,
    freeMode: true,
    watchOverflow: true,
    preloadImages: false,
    lazy: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      501: {
        slidesPerView: 1.6,
        freeMode: true
      },
      651: {
        slidesPerView: 2.2,
        freeMode: false
      },
      961: {
        slidesPerView: 3,
        freeMode: false
      }
    }
  })

  SWIPER.init()
}
